import { createSelector } from 'reselect'

export const selectNettingUpdaterState = state => state.nettingUpdaterTools

export const selectNettingUpdaterOrganizationId = createSelector(
  selectNettingUpdaterState,
  data => data.organizationId
)

export const selectNettingUpdaterStoreData = createSelector(
  selectNettingUpdaterState,
  data => ({
    organizationId: data.organizationId,
    fileName: data.fileName,
    isSubmitting: data.isSubmitting,
    resultError: data.resultError,
    resultMessage: data.resultMessage,
  })
)
